import { Component, OnInit, Input, Output, DoCheck, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";
import { UserService } from "../../../../injections/user.service";

@Component({
    selector: 'user-data',
    templateUrl: '../../templates/partials/user-data.html'
})
export class DataComponent implements OnInit {

    public editFactData: boolean = false;
    public updateUser: FormGroup;
    public dataCopy;
    @Input() data;
    @Input() mgmCode;
    @Output() emitCloseModal = new EventEmitter
    constructor(private _fb: FormBuilder, private userService: UserService) {}

    public toggleEditFactData(){
        this.editFactData = (this.editFactData) ? false : true;
    }

    public emitDisplayModal(type: string) {
        var object = {
            action: "open",
            type: type,
            data: null
        }
        this.emitCloseModal.emit(object);
    }


    public ngOnChanges() {
        //console.log(this.data);
    }

    public modifyCard() {
        //console.log("modifyCard");
    }

    ngOnInit() {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/data.component.ts